<template>
  <div v-if="type">
    <h1>Group assign</h1>
    <h2>{{type.name}}</h2>
    <v-alert
      :value="true"
      color="info"
    >Check the boxes in the table next to the entities you wish to assign. Select the group below to which you want to assign the entities. Then click 'Save'.</v-alert>
    <v-select
      label="Group"
      v-model="groupid"
      :items="groups"
      item-value="id"
      item-text="name"
      outline
    />
    <v-btn @click="updateGroup" :disabled="!selectedEntities.length || !groupid">
      <v-icon>save</v-icon>Save
    </v-btn>
    <v-btn :to="{name:'groupCreate', params:{id:type.id}}">
      <v-icon>add</v-icon>Group
    </v-btn>
    <!-- <div v-for="entity in computedEntities" :key="entity.id">
      <v-checkbox v-model="selectedEntities" :value="entity.id" />
      <EntityZ :entity="entity" />
      <span>{{entity.address}}</span>
    </div>-->
    <v-data-table
      :pagination.sync="pagination"
      :headers="headers"
      :items="computedEntities"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <tr>
          <td>
            <v-checkbox v-model="selectedEntities" :value="props.item.id" />
          </td>
          <td>
            <EntityZ :entity="props.item" />
          </td>
          <td>{{props.item.address}}</td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import EntityZ from "@/components/link/EntityZ";
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "GroupAssign",
  metaInfo() {
    return {
      title: "Group assign",
      titleTemplate: "%s - Directory - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  components: {
    EntityZ
  },
  computed: {
    computedEntities() {
      return this.entities.map(e => {
        const address = this.addresses ? this.addresses[e.id] : undefined;
        return { ...e, address };
      });
    }
  },
  data() {
    return {
      groups: null,
      entities: [],
      addresses: null,
      types: null,
      type: null,
      groupid: null,
      selectedEntities: [],
      headers: [
        {
          text: "Select",
          sortable: false
        },
        {
          text: "Name",
          value: "name"
        },
        {
          text: "Address",
          sortable: false
        }
      ],
      pagination: {
        rowsPerPage: -1,
        sortBy: "name",
        descending: false
      }
    };
  },
  methods: {
    fetchGroups() {
      nbmlaw
        .get(`/cors/admin/directory/types/${this.$route.params.id}/groups`)
        .then(response => {
          // console.log(response.data);
          this.groups = response.data;
        });
    },
    fetchEntities() {
      nbmlaw
        .get(
          `/cors/admin/directory/types/${this.$route.params.id}/entitiesWithoutGroup`
        )
        .then(response => {
          // console.log(response.data);
          this.entities = response.data;
        });
    },
    fetchAddresses() {
      nbmlaw
        .get(
          `/cors/admin/directory/types/${this.$route.params.id}/entitiesWithoutGroup/addresses`
        )
        .then(response => {
          // console.log(response.data);
          this.addresses = response.data;
        });
    },
    fetchTypes() {
      nbmlaw.get(`/cors/admin/directory/types`).then(response => {
        // console.log(response.data);
        this.types = response.data;
      });
    },
    updateGroup() {
      if (confirm("Are you sure?")) {
        nbmlaw
          .put(`/cors/admin/directory/groups/${this.groupid}/entities`, null, {
            params: { selectedEntities: this.selectedEntities.join(".") }
          })
          .then(() => {
            // console.log(response.data);
            this.reset();
          });
      }
    },
    reset() {
      this.update();
      this.selectedEntities = [];
    },
    update() {
      this.fetchGroups();
      this.fetchEntities();
      this.fetchAddresses();
    }
  },
  watch: {
    "$route.params.id": {
      immediate: true,
      handler() {
        if (this.$route.params.id) {
          this.update();
        }
      }
    },
    types: {
      handler() {
        this.type = this.types
          ? this.types.find(t => t.id == this.$route.params.id)
          : undefined;
      }
    }
  },
  created() {
    this.fetchTypes();
  }
};
</script>
